import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=46953bfe&scoped=true"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=46953bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46953bfe",
  null
  
)

export default component.exports